import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'system' | 'light' | 'dark';

interface SettingsState {
  shouldShowGreat78Artists: boolean;
  shouldLoadPreviousBands: boolean;
  shouldLoadPreviousSettings: boolean;
  fullShowMode: boolean;
  continueJamsMode: boolean;
  skipFillerSongs: boolean;
  themeMode: ThemeMode;

  updateThemeMode: (value: ThemeMode) => void;
  updateShouldShowGreat78Artists: (value: boolean) => void;
  updateShouldLoadPreviousBands: (value: boolean) => void;
  updateShouldLoadPreviousSettings: (value: boolean) => void;
  updateFullShowMode: (value: boolean) => void;
  updateContinueJamsMode: (value: boolean) => void;
  updateSkipFillerSongs: (value: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      shouldShowGreat78Artists: true,
      shouldLoadPreviousBands: false,
      shouldLoadPreviousSettings: false,
      fullShowMode: false,
      continueJamsMode: false,
      skipFillerSongs: false,
      themeMode: 'system',

      updateThemeMode: (value) => set({ themeMode: value }),
      updateShouldShowGreat78Artists: (value) => set({ shouldShowGreat78Artists: value }),
      updateShouldLoadPreviousBands: (value) => set({ shouldLoadPreviousBands: value }),
      updateShouldLoadPreviousSettings: (value) => set({ shouldLoadPreviousSettings: value }),
      updateFullShowMode: (value) => set({ fullShowMode: value }),
      updateContinueJamsMode: (value) => set({ continueJamsMode: value }),
      updateSkipFillerSongs: (value) => set({ skipFillerSongs: value }),
    }),
    {
      name: 'live-shuffle-settings',
    }
  )
);